import React from "react";
import Cookie from "browser-cookies";
import axios from "axios";

class Comparison extends React.Component {
  constructor(props) {
    super(props);
    this.checkComparisonProducts = this.checkComparisonProducts.bind(this);
    this.removeProductFromComparison = this.removeProductFromComparison.bind(
      this
    );
    this.removeAllProducts = this.removeAllProducts.bind(this);
    this.state = {
      max_compare: [1, 2, 3],
      cookie_key: "engex_product_compare",
      comparison_products: []
    };
  }

  componentDidMount() {
    PubSub.subscribe("COMPARE_UPDATED", (msg, data) => {
      this.checkComparisonProducts();
    });
    this.checkComparisonProducts();
  }

  checkComparisonProducts() {
    axios
      .get("/products/comparison", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      })
      .then(data => {
        this.setState({
          comparison_products: data.data.products
        });
      })
      .catch(error => {
        // TODO: Error handling
        console.log(error);
        this.setState({
          comparison_products: []
        });
      });
  }

  removeProductFromComparison(e) {
    const cookie_key = "engex_product_compare";
    let current_compare_products = JSON.parse(Cookie.get(cookie_key));
    const catalogue = e.target.getAttribute("data-id");

    if (_.includes(current_compare_products, catalogue)) {
      _.remove(current_compare_products, f => f === catalogue);
    }
    Cookie.set(cookie_key, JSON.stringify(current_compare_products));
    PubSub.publish("COMPARE_UPDATED");
  }

  removeAllProducts(e) {
    e.preventDefault();
    document.cookie =
      "engex_product_compare=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    this.setState({
      comparison_products: []
    });

    let compare_icons = document.querySelectorAll(
      ".product-info__compare-btn > i"
    );
    compare_icons.forEach(c => {
      c.innerHTML = "&#xE836;";
    });
  }

  render() {
    if (this.state.comparison_products.length > 0) {
      return (
        <div className="comparison">
          <div className="comparison-header">
            <h4>Products to Compare</h4>
            <div className="comparison-btns">
              <a
                href="#"
                className="comparison-btns__secondary"
                onClick={this.removeAllProducts}
              >
                Reset
              </a>
              <a
                href="/products/comparison"
                className="comparison-btns__primary"
              >
                Compare
              </a>
            </div>
          </div>
          <div className="comparison-products">
            {_.map(this.state.max_compare, (key, i) => {
              var desc = "";
              if (this.state.comparison_products[i]) {
                desc = (
                  <div className="comparison-product__desc">
                    <img
                      src={this.state.comparison_products[i][
                        "product_image_url"
                      ].replace("medium", "thumbnail")}
                    />
                    <div className="comparison-product__desc__name">
                      {this.state.comparison_products[i]["product_description"]}
                      <div
                        className="comparison-product__remove"
                        data-id={
                          this.state.comparison_products[i]["product_catalogue"]
                        }
                        onClick={this.removeProductFromComparison}
                      >
                        <i
                          className="material-icons"
                          data-id={
                            this.state.comparison_products[i][
                              "product_catalogue"
                            ]
                          }
                        >
                          &#xE5C9;
                        </i>{" "}
                        Remove
                      </div>
                    </div>
                  </div>
                );
              }
              return (
                <div className="comparison-product" key={i}>
                  {desc}
                </div>
              );
            })}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export { Comparison as default };
